import React from 'react';

const Loading: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <div style={style}>Loading...</div>
);

export default Loading;
